import { RichTextField } from '@prismicio/client';
import cx from 'classnames';
import { useState } from 'react';

import { IconFlip360 } from '../../../../../design-system/components/icons/Flip360';
import { IconFlip360Reversed } from '../../../../../design-system/components/icons/Flip360Reversed';
import { BrandHandMarkTwoLinesVariant3 } from '../../../../../design-system/components/illustration/BrandHandMarkTwoLinesVariant3';
import { BrandHandMarkTwoLinesVariant4 } from '../../../../../design-system/components/illustration/BrandHandMarkTwoLinesVariant4';
import { BrandHandMarkTwoLinesVariant5 } from '../../../../../design-system/components/illustration/BrandHandMarkTwoLinesVariant5';
import { EvaneosPrismicRichText } from '../../../../../domains/Prismic/EvaneosPrismicRichText';

import style from './ReasonsToBelieveCard.module.css';

type ReasonsToBelieveProps = {
    title: RichTextField;
    subtitle: RichTextField;
    description: string;
    onClick: ({ isFlipped }: { isFlipped: boolean }) => void;
};

export function ReasonsToBelieveCard({
    title,
    subtitle,
    description,
    onClick,
}: ReasonsToBelieveProps) {
    const [isFlipped, setIsFlipped] = useState(false);

    function handleClick() {
        const isFlippedToggled = !isFlipped;

        setIsFlipped(isFlippedToggled);
        onClick({ isFlipped: isFlippedToggled });
    }

    return (
        <div className={cx(style.card, { [style.isFlipped]: isFlipped })} onClick={handleClick}>
            <div className={style.cardInner}>
                <div className={style.cardFront}>
                    <div className={style.flipIconWrapper}>
                        <IconFlip360 className={style.flipIcon} />
                    </div>
                    <div className={style.content}>
                        <h3 className={style.title}>
                            <EvaneosPrismicRichText
                                field={title}
                                components={{
                                    paragraph: EvaneosPrismicRichText.removeHtmlTag,
                                }}
                            />
                            <BrandHandMarkTwoLinesVariant3 className={style.handMark1} />
                            <BrandHandMarkTwoLinesVariant4 className={style.handMark2} />
                            <BrandHandMarkTwoLinesVariant5 className={style.handMark3} />
                        </h3>
                        <div className={style.subtitle}>
                            <EvaneosPrismicRichText
                                field={subtitle}
                                components={{
                                    paragraph: EvaneosPrismicRichText.removeHtmlTag,
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className={style.cardBack}>
                    <div className={style.flipIconWrapper}>
                        <IconFlip360Reversed className={style.flipIcon} />
                    </div>
                    <div className={style.description}>{description}</div>
                </div>
            </div>
        </div>
    );
}
